import { connect } from "react-redux"
import { withRouter } from "react-router"
import { compose } from "redux"
import LayoutView from "./LayoutView"
import { getLayoutMasterIds } from "utils"
import {
	fetchLayoutDetailBySiteUuid,
	fetchMasterDataByLayoutId,
	fetchMasterDetails,
	fetchNodeDetails,
	subscribeMasterIdUpdates,
	subscribeNodeIdUpdates,
	subscribeNodeSyncBitmasksUpdate,
} from "store/actions/fetchers"
import api from "../../constants/api"
import * as actionTypes from "../../store/actions/types"

const getLayoutTimestamp = (state, props) => {
	const params = new URLSearchParams(props.location.search)
	return parseInt(params.get("ts"))
}

const deviceIdAssignment = (state, props) => {
	const params = new URLSearchParams(props.location.search)
	return params.get("overlay") === "deviceid-assignment"
}

const handleRetrieveComponentsScanned = (dispatch) => (layoutId, componentType, isMaster) => {
	api.retrieveComponentsScanned(layoutId, componentType, isMaster ? "masters" : "nodes").then((result) => {
		dispatch({
			type: isMaster ? actionTypes.SET_MASTER_COMPONENTS_SCANNED : actionTypes.SET_NODE_COMPONENTS_SCANNED,
			value: { componentsScanned: result.body, componentType: componentType },
		})
	})
}

const mapStateToProps = (state, props) => {
	const params = new URLSearchParams(props.location.search)
	return {
		params,
		mLocIds: getLayoutMasterIds(state.layoutDetails, props.match.params.layoutId),
		userPrivileges: state.user.privileges,
		nodeDetails: state.nodeDetails,
		masterDetails: state.masterDetails,
		layoutDetails: state.layoutDetails[props.match.params.layoutId] || {},
		timestamp: getLayoutTimestamp(state, props),
		deviceIdAssignment: deviceIdAssignment(state, props),
		nodesRetrievedPerSite: state.nodesRetrievedPerSite[props.match.params.layoutId],
	}
}

const mapDispatchToProps = (dispatch) => ({
	subscribeNodeIdUpdates: (layoutId) => dispatch(subscribeNodeIdUpdates(layoutId)),
	subscribeMasterIdUpdates: (layoutId) => dispatch(subscribeMasterIdUpdates(layoutId)),
	subscribeNodeSyncBitmasksUpdate: (layoutId) => dispatch(subscribeNodeSyncBitmasksUpdate(layoutId)),
	fetchLayoutDetailsBySiteUuid: (layoutId) => dispatch(fetchLayoutDetailBySiteUuid(layoutId)),
	fetchMasterDataByLayoutId: (layoutId, userPrivileges, deviceType, timestamp) => {
		dispatch(fetchMasterDataByLayoutId(layoutId, userPrivileges, deviceType, timestamp))
	},
	fetchMasterDetails: (layoutId) => {
		dispatch(fetchMasterDetails(layoutId))
	},
	fetchNodeDetails: (layoutId, masterDetails) => {
		dispatch(fetchNodeDetails(layoutId, masterDetails))
	},
	handleRetrieveComponentsScanned: handleRetrieveComponentsScanned(dispatch),
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(LayoutView)
